import SpinningDots from './SpinningDots'

export default SpinningDots
